import { render } from "./ParentsList.vue?vue&type=template&id=24e4ff45&scoped=true"
import script from "./ParentsList.vue?vue&type=script&lang=js"
export * from "./ParentsList.vue?vue&type=script&lang=js"

import "./ParentsList.vue?vue&type=style&index=0&id=24e4ff45&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e4ff45"]])

export default __exports__